import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Table,
  Tooltip,
  Button,
  Form,
  Spin,
  Row,
  Col,
  Input,
  Modal,
  Divider,
  Space,
  Select,
  DatePicker,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { FolderOpenOutlined, EditOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import CustomPagination from "../../../../../../components/CustomPagination";

const dateFormat = "YYYY-MM-DD";

const Transactions = (props) => {
  const navigate = useNavigate();
  const {
    state,
    userData,
    refreshList,
    currentPage,
    setCurrentPage,
    tableCount,
    setTableCount,
    totalItems,
    setTotalItems,
    onRefresh,
    transactionsList,
  } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
    },
    {
      title: "Debit",
      dataIndex: "debit",
    },
    {
      title: "Credit",
      dataIndex: "credit",
    },
    {
      title: "Balance",
      dataIndex: "balance",
    },
    {
      title: "View Receipt",
      dataIndex: "viewReceipt",
    },
    {
      title: "Actions",
      // dataIndex: "actions",
      render: (_, record) => (
        <>
          <DetailTransactions
            currentCustomerObj={state}
            userData={userData}
            transactionObj={record}
            // refreshList={getClientLimit}
          />
          &nbsp;
          {BOM.HasPermission("ADJUSTTRANSACTION_RECURRINGDEPOSITACCOUNT") && (
            <EditTransactions
              currentCustomerObj={state}
              userData={userData}
              transactionObj={record}
              refreshList={refreshList}
            />
          )}
        </>
      ),
    },
  ];

  function handleJournalEntries() {
    navigate("/recurring-journal-entries", { state: state });
  }

  return (
    <>
      <Spin spinning={isLoading} size="large">
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={handleJournalEntries}
        >
          <FolderOpenOutlined />
          &nbsp;{labelConfig.viewJournalEntries}
        </Button>
        <Divider orientation="left" />

        <Table pagination={false} columns={columns} dataSource={transactionsList} />
        {/* <CustomPagination
          totalItems={totalItems}
          pageSize={Number(tableCount)}
          onPageChange={(page, offset) => onRefresh(offset)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        /> */}
      </Spin>
    </>
  );
};

export default Transactions;

const DetailTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    setIsLoading(true);
    const url = `${apiConfig.Recurringdepositaccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setTransactionsDetail(objDetail);

        setInputField([
          {
            name: labelConfig.transactionId,
            value: objDetail?.id,
            type: "general",
          },
          {
            name: labelConfig.transactionType,
            value: objDetail?.transactionType?.value,
            type: "general",
          },
          {
            name: labelConfig.date,
            value: BOM.FormatArrayDate(objDetail?.date),
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency?.displayLabel,
            type: "general",
          },
          {
            name: labelConfig.amount,
            value: objDetail.amount,
            type: "general",
          },

          {
            name: labelConfig.lienTransaction,
            value: objDetail.lienTransaction,
            type: "general",
          },
          {
            name: labelConfig.totalWithdrawalFees,
            value: objDetail?.summary?.totalWithdrawalFees,
            type: "general",
          },

          {
            name: labelConfig.paymentDetail,
            value: objDetail?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },
        ]);

        setIsLoading(false);
      }
    });
  };
  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onUndoTransaction = (key) => {
    const formValues = {};

    formValues.transactionAmount = key?.amount;
    formValues.transactionDate = BOM.DateTime(key.date, "only-date");
    formValues.dateFormat = "dd MMMM yyyy";

    let action = "Reverse ";
    let label = "Transaction";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const params = {
          command: "undo",
        };
        const url = `${apiConfig.Recurringdepositaccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

        const body = {
          method: "POST",
          locale: "en",
          ...formValues,
          session,
          params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.TransactionSuccessfullyReversed);

            // close modal
            setIsModalOpen(false);

            //refresh the list
            // refreshList();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Transaction Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {BOM.HasPermission("UNDOTRANSACTION_RECURRINGDEPOSITACCOUNT") && (
                  <Button
                    type="primary"
                    shape="round"
                    className="of-primaryBtnColor"
                    onClick={() => onUndoTransaction(transactionsDetail)}
                    danger={true}
                  >
                    Reverse
                  </Button>
                )}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input disabled value={item.value} className="of-bold-disable-input" />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

const EditTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj, refreshList } = props;

  const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [paymentTypesData, setPaymentTypesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  function getTemplate() {
    const params = {
      template: true,
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentTypes = [];

        objDetail?.paymentTypeOptions.forEach((element) => {
          tempPaymentTypes.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypesData(tempPaymentTypes);

        useForm.setFieldsValue({
          transactionDate: dayjs(BOM.FormatArrayDate(objDetail?.date), dateFormat),
          transactionAmount: objDetail?.amount,
          paymentTypeId: objDetail?.paymentDetailData?.paymentType?.id,
        });

        setIsLoading(false);
      }
    });
  }

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "modify",
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${currentCustomerObj.id}/transactions/${transactionObj.id}`;

    formValues.transactionDate = BOM.DateTime(formValues.transactionDate, "only-date");

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editTransactionMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          refreshList();
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <>
      <Tooltip title={`Edit`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Transaction"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionDate}
                name="transactionDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionDate),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.transactionAmount}
                name="transactionAmount"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionAmount),
                  },
                ]}
              >
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.transactionAmount)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item disabled label={labelConfig.paymentTypes} name="paymentTypeId">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.paymentTypes} *`, "select")}
                  options={paymentTypesData}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Divider orientation="left">{`${labelConfig.paymentDetail}s`}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.accountNumber} name="accountNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.accountNumber)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.chequeNumber} name="chequeNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.chequeNumber)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.routingCode} name="routingCode">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.routingCode)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.receiptNumber} name="receiptNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.receiptNumber)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.bankNumber} name="bankNumber">
                <Input
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.bankNumber)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
